import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { X } from 'lucide-react';
type LegalType = 'privacy' | 'terms' | null;
const legalContent: Record<'privacy' | 'terms', {
  title: string;
  body: React.ReactNode;
}> = {
  privacy: {
    title: 'Política de Privacidad',
    body: <div className="space-y-6 text-gray-600 leading-relaxed" data-id="element-19">
        <p data-id="element-20">
          <strong className="text-gray-900" data-id="element-21">Última actualización:</strong>{' '}
          Febrero 2026
        </p>

        <section data-id="element-22">
          <h3 className="text-lg font-bold text-gray-900 mb-2" data-id="element-23">
            1. Información que recopilamos
          </h3>
          <p data-id="element-24">
            Cuando compras "Inglés Sin Pena (7 días)", recopilamos únicamente la
            información necesaria para procesar tu compra: nombre, dirección de
            correo electrónico y datos de pago. No almacenamos información de
            tarjetas de crédito directamente; los pagos son procesados de forma
            segura por nuestro proveedor de pagos.
          </p>
        </section>

        <section data-id="element-25">
          <h3 className="text-lg font-bold text-gray-900 mb-2" data-id="element-26">
            2. Uso de la información
          </h3>
          <p data-id="element-27">Usamos tu información para:</p>
          <ul className="list-disc pl-6 mt-2 space-y-1" data-id="element-28">
            <li data-id="element-29">Enviarte el producto digital que compraste</li>
            <li data-id="element-30">Comunicarnos contigo sobre tu compra</li>
            <li data-id="element-31">Enviarte actualizaciones del producto (si aplica)</li>
          </ul>
          <p className="mt-2" data-id="element-32">
            No vendemos, alquilamos ni compartimos tu información personal con
            terceros para fines de marketing.
          </p>
        </section>

        <section data-id="element-33">
          <h3 className="text-lg font-bold text-gray-900 mb-2" data-id="element-34">3. Cookies</h3>
          <p data-id="element-35">
            Este sitio puede utilizar cookies básicas para mejorar tu
            experiencia de navegación y analizar el tráfico del sitio. No
            utilizamos cookies para rastrear tu actividad en otros sitios web.
          </p>
        </section>

        <section data-id="element-36">
          <h3 className="text-lg font-bold text-gray-900 mb-2" data-id="element-37">4. Seguridad</h3>
          <p data-id="element-38">
            Implementamos medidas de seguridad razonables para proteger tu
            información personal. Sin embargo, ningún método de transmisión por
            Internet es 100% seguro.
          </p>
        </section>

        <section data-id="element-39">
          <h3 className="text-lg font-bold text-gray-900 mb-2" data-id="element-40">
            5. Tus derechos
          </h3>
          <p data-id="element-41">
            Puedes solicitar acceso, corrección o eliminación de tus datos
            personales en cualquier momento contactándonos directamente.
          </p>
        </section>

        <section data-id="element-42">
          <h3 className="text-lg font-bold text-gray-900 mb-2" data-id="element-43">
            6. Cambios a esta política
          </h3>
          <p data-id="element-44">
            Nos reservamos el derecho de actualizar esta política. Cualquier
            cambio será publicado en esta página con la fecha de actualización
            correspondiente.
          </p>
        </section>
      </div>
  },
  terms: {
    title: 'Términos y Condiciones',
    body: <div className="space-y-6 text-gray-600 leading-relaxed" data-id="element-45">
        <p data-id="element-46">
          <strong className="text-gray-900" data-id="element-47">Última actualización:</strong>{' '}
          Febrero 2026
        </p>

        <section data-id="element-48">
          <h3 className="text-lg font-bold text-gray-900 mb-2" data-id="element-49">
            1. Producto digital
          </h3>
          <p data-id="element-50">
            "Inglés Sin Pena (7 días)" es un producto digital en formato PDF. Al
            completar tu compra, recibirás acceso inmediato para descargar el
            archivo. Este producto es para uso personal y no puede ser
            redistribuido, revendido ni compartido.
          </p>
        </section>

        <section data-id="element-51">
          <h3 className="text-lg font-bold text-gray-900 mb-2" data-id="element-52">
            2. Precio y pago
          </h3>
          <p data-id="element-53">
            El precio del producto es de $6.58 USD (pago único). No hay cargos
            recurrentes ni suscripciones. El pago se procesa de forma segura a
            través de nuestro proveedor de pagos autorizado.
          </p>
        </section>

        <section data-id="element-54">
          <h3 className="text-lg font-bold text-gray-900 mb-2" data-id="element-55">
            3. Política de reembolso
          </h3>
          <p data-id="element-56">
            Debido a la naturaleza digital del producto (descarga inmediata),
            todas las ventas son finales. Si tienes algún problema técnico con
            la descarga, contáctanos y te ayudaremos a resolverlo.
          </p>
        </section>

        <section data-id="element-57">
          <h3 className="text-lg font-bold text-gray-900 mb-2" data-id="element-58">
            4. Propiedad intelectual
          </h3>
          <p data-id="element-59">
            Todo el contenido de "Inglés Sin Pena (7 días)" — incluyendo textos,
            guiones, frases y diseño — está protegido por derechos de autor.
            Queda prohibida su reproducción, distribución o modificación sin
            autorización expresa.
          </p>
        </section>

        <section data-id="element-60">
          <h3 className="text-lg font-bold text-gray-900 mb-2" data-id="element-61">
            5. Resultados
          </h3>
          <p data-id="element-62">
            Los resultados pueden variar según la dedicación y práctica de cada
            persona. No garantizamos resultados específicos. El producto ofrece
            herramientas y un método práctico, pero el progreso depende del
            esfuerzo individual.
          </p>
        </section>

        <section data-id="element-63">
          <h3 className="text-lg font-bold text-gray-900 mb-2" data-id="element-64">
            6. Limitación de responsabilidad
          </h3>
          <p data-id="element-65">
            Este producto es un recurso educativo y no sustituye clases formales
            de inglés ni asesoría profesional. No nos hacemos responsables por
            decisiones tomadas basándose en el contenido del PDF.
          </p>
        </section>

        <section data-id="element-66">
          <h3 className="text-lg font-bold text-gray-900 mb-2" data-id="element-67">
            7. Modificaciones
          </h3>
          <p data-id="element-68">
            Nos reservamos el derecho de modificar estos términos en cualquier
            momento. Los cambios entrarán en vigor al ser publicados en esta
            página.
          </p>
        </section>
      </div>
  }
};
export function Footer() {
  const [openModal, setOpenModal] = useState<LegalType>(null);
  // Lock body scroll when modal is open
  useEffect(() => {
    if (openModal) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = '';
    }
    return () => {
      document.body.style.overflow = '';
    };
  }, [openModal]);
  return <>
      <footer className="bg-gray-900 py-10 px-4" data-id="element-69">
        <div className="max-w-4xl mx-auto flex flex-col items-center gap-4" data-id="element-70">
          <div className="flex items-center gap-6" data-id="element-71">
            <button onClick={() => setOpenModal('privacy')} className="text-gray-400 hover:text-white text-sm transition-colors underline underline-offset-4 decoration-gray-600 hover:decoration-white" data-id="element-72">
              Política de Privacidad
            </button>
            <span className="text-gray-700" data-id="element-73">•</span>
            <button onClick={() => setOpenModal('terms')} className="text-gray-400 hover:text-white text-sm transition-colors underline underline-offset-4 decoration-gray-600 hover:decoration-white" data-id="element-74">
              Términos y Condiciones
            </button>
          </div>
          <p className="text-gray-600 text-sm" data-id="element-75">
            © {new Date().getFullYear()} Inglés Sin Pena. Todos los derechos
            reservados.
          </p>
        </div>
      </footer>

      {/* Legal Modal */}
      <AnimatePresence data-id="element-76">
        {openModal && <motion.div initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} exit={{
        opacity: 0
      }} transition={{
        duration: 0.2
      }} className="fixed inset-0 z-50 flex items-center justify-center p-4" onClick={() => setOpenModal(null)} data-id="element-77">
            {/* Backdrop */}
            <div className="absolute inset-0 bg-black/60 backdrop-blur-sm" data-id="element-78" />

            {/* Modal */}
            <motion.div initial={{
          opacity: 0,
          scale: 0.95,
          y: 20
        }} animate={{
          opacity: 1,
          scale: 1,
          y: 0
        }} exit={{
          opacity: 0,
          scale: 0.95,
          y: 20
        }} transition={{
          duration: 0.25,
          ease: 'easeOut'
        }} onClick={e => e.stopPropagation()} className="relative bg-white rounded-2xl shadow-2xl w-full max-w-2xl max-h-[85vh] flex flex-col overflow-hidden" data-id="element-79">
              {/* Header */}
              <div className="flex items-center justify-between px-6 py-5 border-b border-gray-100 flex-shrink-0" data-id="element-80">
                <h2 className="text-xl font-bold text-gray-900" data-id="element-81">
                  {legalContent[openModal].title}
                </h2>
                <button onClick={() => setOpenModal(null)} className="w-9 h-9 flex items-center justify-center rounded-full hover:bg-gray-100 transition-colors text-gray-500 hover:text-gray-900" aria-label="Cerrar" data-id="element-82">
                  <X className="w-5 h-5" data-id="element-83" />
                </button>
              </div>

              {/* Body */}
              <div className="px-6 py-6 overflow-y-auto flex-1" data-id="element-84">
                {legalContent[openModal].body}
              </div>

              {/* Footer */}
              <div className="px-6 py-4 border-t border-gray-100 flex-shrink-0" data-id="element-85">
                <button onClick={() => setOpenModal(null)} className="w-full py-3 bg-gray-900 text-white rounded-full font-semibold hover:bg-gray-800 transition-colors text-sm" data-id="element-86">
                  Entendido
                </button>
              </div>
            </motion.div>
          </motion.div>}
      </AnimatePresence>
    </>;
}